<template>
  <div class="tipo-ligacao-container">
    <div class="tipo-btn-group">
      <div
        class="tipo-btn-wrapper"
        :class="{ 'is-selected': ligAtivButton === 'border' }"
        @click="selectInteraction(1)"
      >
        <vx-tooltip color="success" text="Ligação Ativa">
          <vs-button
            icon="add_ic_call"
            color="success"
            radius
            size="small"
            :type="ligAtivButton"
          ></vs-button>
        </vx-tooltip>
        <span class="tipo-btn-label tipo-label-success" :class="{ active: ligAtivButton === 'border' }">Ligação Ativa</span>
      </div>
      <div
        class="tipo-btn-wrapper"
        :class="{ 'is-selected': ligRecepButton === 'border' }"
        @click="selectInteraction(2)"
      >
        <vx-tooltip color="warning" text="Ligação Receptiva">
          <vs-button
            icon="phone_callback"
            color="warning"
            radius
            size="small"
            :type="ligRecepButton"
          ></vs-button>
        </vx-tooltip>
        <span class="tipo-btn-label tipo-label-warning" :class="{ active: ligRecepButton === 'border' }">Ligação Receptiva</span>
      </div>
      <div
        class="tipo-btn-wrapper"
        :class="{ 'is-selected': abordAtivButton === 'border' }"
        @click="selectInteraction(3)"
      >
        <vx-tooltip color="blue" text="Abordagem Ativa">
          <vs-button
            icon="streetview"
            color="blue"
            radius
            size="small"
            :type="abordAtivButton"
          ></vs-button>
        </vx-tooltip>
        <span class="tipo-btn-label tipo-label-blue" :class="{ active: abordAtivButton === 'border' }">Abordagem Ativa</span>
      </div>
      <div
        class="tipo-btn-wrapper"
        :class="{ 'is-selected': abordRecepButton === 'border' }"
        @click="selectInteraction(4)"
      >
        <vx-tooltip color="danger" text="Abordagem Receptiva">
          <vs-button
            icon="drive_eta"
            color="danger"
            radius
            size="small"
            :type="abordRecepButton"
          ></vs-button>
        </vx-tooltip>
        <span class="tipo-btn-label tipo-label-danger" :class="{ active: abordRecepButton === 'border' }">Abordagem Receptiva</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    opcao: null,
  },
  data() {
    return {
      ligAtivButton: "flat",
      ligRecepButton: "flat",
      abordAtivButton: "flat",
      abordRecepButton: "flat",
      tooltip: false,
    };
  },
  methods: {
    async selectInteraction(button) {
      if (button == 1) {
        this.ligAtivButton = "border";
        this.ligRecepButton = "flat";
        this.abordAtivButton = "flat";
        this.abordRecepButton = "flat";
      }
      if (button == 2) {
        this.ligAtivButton = "flat";
        this.ligRecepButton = "border";
        this.abordAtivButton = "flat";
        this.abordRecepButton = "flat";
      }
      if (button == 3) {
        this.ligAtivButton = "flat";
        this.ligRecepButton = "flat";
        this.abordAtivButton = "border";
        this.abordRecepButton = "flat";
      }
      if (button == 4) {
        this.ligAtivButton = "flat";
        this.ligRecepButton = "flat";
        this.abordAtivButton = "flat";
        this.abordRecepButton = "border";
      }
      await this.$emit("select-interaction", button);
    },
  },
  async mounted() {
    if (this.opcao) {
      await this.selectInteraction(this.opcao);
    } else {
      await this.selectInteraction(1);
    }
  },
};
</script>

<style scoped>
.tipo-ligacao-container {
  display: flex;
  align-items: center;
}
.tipo-btn-group {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.tipo-btn-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 10px;
  transition: background-color 0.2s ease;
}
.tipo-btn-wrapper:hover {
  background: rgba(0, 0, 0, 0.03);
}
.tipo-btn-wrapper.is-selected {
  background: rgba(0, 0, 0, 0.04);
}
.tipo-btn-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #9ca3af;
  transition: color 0.2s, opacity 0.2s;
  text-align: center;
  white-space: nowrap;
}
.tipo-btn-label.active {
  opacity: 1;
}
.tipo-label-success.active { color: #28c76f; }
.tipo-label-warning.active { color: #ff9f43; }
.tipo-label-blue.active { color: #2196f3; }
.tipo-label-danger.active { color: #ea5455; }
</style>

